/* eslint-disable react/jsx-pascal-case */
import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import {
  BackgroundArea,
  RowView,
} from "../../../../Component/style/common_style";

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 100%;
  max-width: 27rem;
  margin: auto 0rem;
  background-color: white;
  color: #454545;
  border-radius: 24px;
  overflow: hidden;
  padding: 24px 24px 30px 24px;
  z-index: 99;
  color: #1d1d1d;
  div.info {
    line-height: 25px;
  }
`;

const Content_Box = styled.div`
  padding: 44px 0px 44px 0px;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 16px;
  color: #2d2d2d;
`;

const BtnArea = styled(RowView)`
  div {
    flex: 1;
    padding: 0.8rem 0rem;
    font-family: var(--font-Pretendard-SemiBold);
    text-align: center;
    color: white;
    background-image: linear-gradient(to bottom right, #ec7a58, #ea2922);
    border-radius: 8px;
    cursor: pointer;
  }
`;

const Live_End_Modal = (props: modalProps) => {
  const isOpen = props.visible;
  const setIsOpen = props.handleModal;
  const Navigate = useNavigate();
  const go_home = () => Navigate("/", { replace: true });
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null);

  const Close = () => {
    setIsOpen();
    go_home();
  };

  useEffect(() => {
    if (isOpen) {
      timeoutIdRef.current = setTimeout(() => {
        Close();
      }, 10000);

      // 클린업 함수에서 타이머를 정리
      return () => {
        if (timeoutIdRef.current) {
          clearTimeout(timeoutIdRef.current);
          timeoutIdRef.current = null;
        }
      };
    }
  }, [isOpen]);

  const handleClose = () => {
    if (timeoutIdRef.current) {
      clearTimeout(timeoutIdRef.current);
      timeoutIdRef.current = null;
    }
    Close();
  };

  return (
    <BackgroundArea style={isOpen ? {} : { display: "none" }} translate="no">
      <ModalBox>
        <Content_Box className="info">방송이 종료되었습니다.</Content_Box>

        <BtnArea>
          <div onClick={handleClose}>확인</div>
        </BtnArea>
      </ModalBox>
    </BackgroundArea>
  );
};

export default Live_End_Modal;
